module.exports = __webpack_public_path__ + "img/image 2.76b78baf.png";